import { FormattedMessage } from 'react-intl';

import { useSearchBar } from '@xing-com/crate-jobs-hooks';

import * as S from './conversational-search-bar.styles';
import { SearchBar } from './search-bar';

export const ConversationalSearchBar: React.FC = () => {
  const { keywords, location, onSubmit, ...result } = useSearchBar();

  return (
    <S.Container>
      <S.Title>
        <FormattedMessage id="JOBS_SEARCH_AI_HEADLINE" />
        <S.Icon />
      </S.Title>
      <SearchBar
        keywordsInput={keywords}
        locationInput={location}
        onSubmit={onSubmit}
        {...result}
      />
    </S.Container>
  );
};
